<template>
  <div>
    <div class="form-group">
      <label for="street">Billing Street</label>

      <input type="text" id="street" class="form-control" v-model="street" @blur="onBlur" :disabled="disabled">
    </div>

    <div class="form-group">
      <label for="street">Billing City</label>

      <input type="text" id="city" class="form-control" v-model="city" @blur="onBlur" :disabled="disabled">
    </div>

    <state-select v-model="state" :disabled="disabled" :states="states" class="mb-4"/>

    <div class="form-group">
      <label for="street">Billing Zip</label>

      <input type="text" id="zip" class="form-control" v-model="zip" @blur="onBlur" :disabled="disabled">
    </div>
  </div>
</template>

<script>
import StateSelect from "./StateSelect";

export default {
  name: 'billing-address',
  components: {StateSelect},
  props: {
    disabled: {
      type: Boolean,
    },
    states: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      state: '',
      street: '',
      city: '',
      zip: '',
    };
  },
  computed: {
    address() {
      return {
        state: this.state,
        street: this.street,
        city: this.city,
        zip: this.zip,
      };
    },
  },
  watch: {
    state() {
      this.$emit('change', this.address);
    }
  },
  methods: {
    onBlur() {
      this.$emit('change', this.address);
    },
  }
};
</script>

<style lang="scss" scoped></style>
